import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IKindPropertyType } from '../model/kind/KindPropertyType';
import { useParams } from 'react-router-dom';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useKindPropertyTypesResult {
    isLoaded: boolean;
    kindPropertyTypes: IKindPropertyType[] | null;
}

export const useKindPropertyTypes = () => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();
    const { projectId } = useParams<{ projectId: string }>();

    const [result, setResult] = useState<useKindPropertyTypesResult>({ isLoaded: false, kindPropertyTypes: [] });

    useEffect(() => {
        setResult({ isLoaded: false, kindPropertyTypes: [] });

        rootStore.kindPropertyTypeStore.loadKindPropertyTypes()
            .then(() => {
                setResult({ isLoaded: true, kindPropertyTypes: rootStore.kindPropertyTypeStore.kindPropertyTypes });
            })
            .catch(e => publishNotification({
                text: 'Error loading kindPropertyTypes',
                canClose: true
            }));
    }, [rootStore.kindPropertyTypeStore, publishNotification, projectId]);

    return result;
};
